import { AuthService } from './../../services/auth.service';
import { LoanappService } from './../../services/loanapp.service';
import { ReceiptService } from './../../services/receipt.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.css'],
})
export class ReceiptComponent implements OnInit {
  appId: String;
  uId: String;
  appdetails: any;
  insDetails: any;
  dataToShow: any;
  farmerDetails: any;
  qrCode: Boolean = false;
  receiptG: Boolean = false;
  myAngularxQrCode: string = null;
  baseURI: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private rService: ReceiptService,
    private lservice: LoanappService,
    private auth: AuthService,
    private toastr: ToastrService
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.appId = params['appId'];
      this.uId = params['uId'];
    });
    this.baseURI = 'https://warehouses.whrrl.in';
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.lservice.getLAppDetailsForReceipt(this.appId, this.uId).subscribe(
      (data) => {
        if (data['success']) {
          this.appdetails = data['data'];
          this.receiptG = true;
          this.myAngularxQrCode =
            this.baseURI + '/receipt?appId=' + this.appId + '&uId=' + this.uId;
          if (this.appdetails['applicationStatus'] != 'approved') {
            this.router.navigateByUrl(
              '/depositapplicationdetails?id=' + this.appId + '&uId=' + this.uId
            );
          }
          this.dataToShow = data['data'];
          this.farmerDetails = data['user'];
          this.insDetails = data['insD'];
        } else {
          this.toastr.error('Something went wrong. Please try again.');
        }
      },
      (err) => {
        this.toastr.error('Error occurred. Please try again.');
      }
    );
  }

  qrCodee() {
    this.receiptG = false;
    this.qrCode = true;
  }

  print(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    let originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    document.body.innerHTML = originalContents;
  }

  reC() {
    this.receiptG = true;
    this.qrCode = false;
  }
}
